import React from 'react';
import AtlasV2DorisDoubleDropdownChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisDoubleDropdownChart';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { useDorisEntityDropdownOptions } from 'src/components/AtlasV2Components/AtlasV2TrafficV2PageComponents/AtlasV2TotalTrafficV2/AtlasV2TotalTrafficDoubleDropdownTopEntity';
import { GroupByField } from 'src/components/AtlasV2Components/AtlasV2TrafficV2PageComponents/AtlasV2TotalTrafficV2/AtlasV2TrafficDropdownTopEntityTraffic';
import { DorisDropdownFieldNameEnum } from 'src/components/AtlasV2Components/Consts/DorisFieldNameEnum';
import { useSalesCustomGroupBy } from 'src/components/AtlasV2Components/Hooks/useSalesCustomGroupBy';
import { CHART_NAMES } from 'src/utils/chartContext/chartContextRegistry';

const AtlasSalesNon1PDropdownTopEntityChart = ({
  groupByFields,
  enableSearchableGroupBy
}: {
  groupByFields?: GroupByField[];
  enableSearchableGroupBy?: boolean;
}) => {
  const dropdownOptions = useDorisEntityDropdownOptions(DorisDropdownFieldNameEnum.Sales);

  const { computedGroupByFields, selectedGroupByField, additionalParams, renderGroupBySelector } =
    useSalesCustomGroupBy({
      enabled: !!enableSearchableGroupBy,
      groupByFields: (groupByFields || dropdownOptions) as GroupByField[]
    });

  return (
    <AtlasV2DorisDoubleDropdownChart
      groupByFields={computedGroupByFields}
      selectedGroupByField={selectedGroupByField}
      fields={[
        {
          fieldName: 'retailSales',
          label: 'Retail Sales',
          metricType: 'retailSales',
          metricTypeDisplay: METRICTYPE.MONEY
        }
      ]}
      queryKey="sales_doubleDropdownTopEntityChart"
      endPoint="sales/GetSalesMetrics"
      chartContextId={CHART_NAMES.SALES_TOP_ENTITY_COLUMN}
      additionalParams={additionalParams}
      renderGroupBySelector={renderGroupBySelector}
    />
  );
};
export default AtlasSalesNon1PDropdownTopEntityChart;
